import {connect} from 'react-redux';
import SquadDeleteModal from './SquadDeleteModal.jsx';
import {handleCloseDeleteModal, handleSquadDelete} from './actions';

const mapStateToProps = state => state.tournament.squads.squadDeleteModal;

const mapDispatchToProps = dispatch => ({
  onCancelClick: () => dispatch(handleCloseDeleteModal()),
  onDeleteClick: () => dispatch(handleSquadDelete())
});

export default connect(mapStateToProps, mapDispatchToProps)(SquadDeleteModal);



// WEBPACK FOOTER //
// ./src/features/tournament/squads/SquadDeleteModalContainer.jsx